export enum FeatureFlag {
  ENABLE_EMBEDDED_INSURANCE_COMPONENT = 'EnableEmbeddedInsuranceComponent',
  ENABLE_EMBEDDED_INSURANCE_VERIFICATION_REDIRECT = 'EnableEmbeddedInsuranceVerificationRedirect',
  ENABLE_INCOME_VERIFICATION_UPLOAD = 'EnableIncomeVerificationUpload',
  ENABLE_LOAN_DOCUMENTS_MODULE = 'EnableLoanDocumentsModule',
  ENABLE_ORIGIN_CHANNEL_ATTRIBUTION_FOR_NEW_APPS = 'EnableOriginChannelAttributionForNewApps',
  ENABLE_PLATE_TO_VIN_SERVICE = 'EnablePlateToVinService',
  ENABLE_REFANDI_COMPONENT_HIGHLIGHT = 'EnableRefandiComponentHighlight',
  ENABLE_REFANDI_SIGN_UP_COPY = 'EnableRefandiSignUpCopy',
  ENABLE_SIMPLIFIED_LOAN_DOCUMENTS_WORKFLOW = 'EnableSimplifiedLoanDocumentsWorkflow',
  ENABLE_SMS_OPT_IN_CHECKBOX = 'EnableSMSOptInCheckbox',
}
